(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this._mql = window.matchMedia('(max-width: 990px)');
      this._onMqlChange = this.setHeaderHeight.bind(this);
      this._mql.addEventListener('change', this._onMqlChange);

      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.initSkinnifyNewDesignEnhancements();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this._mql && this._onMqlChange) this._mql.removeEventListener('change', this._onMqlChange);
    }

    createObserver() {
      if (!this.header) return;
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    initSkinnifyNewDesignEnhancements() {
      const root = this.closest('[data-sf-header]');
      if (!root) return;

      if (root.dataset.sfScrollInit === '1') return;
      root.dataset.sfScrollInit = '1';

      const sectionId = root.getAttribute('data-sf-header');
      const scrolledClass = `sf-scrolled-${sectionId}`;
      const revealClass = `sf-ann-reveal-${sectionId}`;

      let lastScrolled = null;
      let revealTimer = null;
      let ticking = false;

      const mqlDesktop = window.matchMedia('(min-width: 990px)');
      const isStickyEnabled = () => {
        const d = root.getAttribute('data-sf-sticky-d') === '1';
        const m = root.getAttribute('data-sf-sticky-m') === '1';
        return mqlDesktop.matches ? d : m;
      };

      const nudgeBackdrop = () => {
        // Tiny css var nudge forces backdrop-filter to re-sample immediately (prevents 0.5–1s lag on some GPUs/browsers)
        root.style.setProperty('--sf-bdfix', '0.01px');
        requestAnimationFrame(() => root.style.setProperty('--sf-bdfix', '0px'));
      };

      const applyState = () => {
        ticking = false;

        if (!isStickyEnabled()) {
          root.classList.remove(scrolledClass);
          root.classList.remove(revealClass);
          lastScrolled = null;
          if (revealTimer) {
            clearTimeout(revealTimer);
            revealTimer = null;
          }
          return;
        }

        const scrolled = window.scrollY > 2;

        if (scrolled) {
          root.classList.add(scrolledClass);
          root.classList.remove(revealClass);
          if (revealTimer) {
            clearTimeout(revealTimer);
            revealTimer = null;
          }
        } else {
          root.classList.remove(scrolledClass);

          // Ensure blur is correct immediately when returning to top
          nudgeBackdrop();

          if (lastScrolled === true) {
            root.classList.add(revealClass);
            if (revealTimer) clearTimeout(revealTimer);
            revealTimer = setTimeout(() => {
              root.classList.remove(revealClass);
            }, 700);
          } else {
            root.classList.remove(revealClass);
          }
        }

        lastScrolled = scrolled;
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(applyState);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      applyState();
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Fallback when sticky_header_type == 'none' */
  (() => {
    const initAll = () => {
      document.querySelectorAll('[data-sf-header]').forEach((root) => {
        if (root.dataset.sfScrollInit === '1') return;
        root.dataset.sfScrollInit = '1';

        const sectionId = root.getAttribute('data-sf-header');
        const scrolledClass = `sf-scrolled-${sectionId}`;
        const revealClass = `sf-ann-reveal-${sectionId}`;

        let lastScrolled = null;
        let revealTimer = null;
        let ticking = false;

        const mqlDesktop = window.matchMedia('(min-width: 990px)');
        const isStickyEnabled = () => {
          const d = root.getAttribute('data-sf-sticky-d') === '1';
          const m = root.getAttribute('data-sf-sticky-m') === '1';
          return mqlDesktop.matches ? d : m;
        };

        const nudgeBackdrop = () => {
          root.style.setProperty('--sf-bdfix', '0.01px');
          requestAnimationFrame(() => root.style.setProperty('--sf-bdfix', '0px'));
        };

        const applyState = () => {
          ticking = false;

          if (!isStickyEnabled()) {
            root.classList.remove(scrolledClass);
            root.classList.remove(revealClass);
            lastScrolled = null;
            if (revealTimer) {
              clearTimeout(revealTimer);
              revealTimer = null;
            }
            return;
          }

          const scrolled = window.scrollY > 2;

          if (scrolled) {
            root.classList.add(scrolledClass);
            root.classList.remove(revealClass);
            if (revealTimer) {
              clearTimeout(revealTimer);
              revealTimer = null;
            }
          } else {
            root.classList.remove(scrolledClass);
            nudgeBackdrop();

            if (lastScrolled === true) {
              root.classList.add(revealClass);
              if (revealTimer) clearTimeout(revealTimer);
              revealTimer = setTimeout(() => {
                root.classList.remove(revealClass);
              }, 700);
            } else {
              root.classList.remove(revealClass);
            }
          }

          lastScrolled = scrolled;
        };

        const onScroll = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(applyState);
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        applyState();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  (function () {
    const roots = () => Array.from(document.querySelectorAll('[data-sf-ann]'));

    const formatMoney = (cents, moneyFormat, moneySample) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      // Fallback: infer localized prefix/suffix from the Liquid-rendered sample
      // Example sample could be "$1.00", "1,00 €", "€1,00"
      const value = (cents / 100).toFixed(2);
      const sample = String(moneySample || '');

      const sampleMatch = sample.match(/^(.*?)(\d[\d.,\s]*)(.*?)$/);
      if (sampleMatch) {
        const prefix = sampleMatch[1] || '';
        const numberPart = sampleMatch[2] || '1.00';
        const suffix = sampleMatch[3] || '';

        let formattedNumber = value;

        // If sample uses comma decimal, mirror that
        if (
          numberPart.includes(',') &&
          (!numberPart.includes('.') || numberPart.lastIndexOf(',') > numberPart.lastIndexOf('.'))
        ) {
          formattedNumber = value.replace('.', ',');
        }

        return `${prefix}${formattedNumber}${suffix}`;
      }

      return value;
    };

    const computeFsMessage = (cart, cfg) => {
      const enabled = cfg.fsEnabled === '1';
      const thresholdCents = Number(cfg.threshold || 0); // already in cents
      if (!enabled || !thresholdCents) return null;

      const total = Number(cart?.total_price || 0);
      let remaining = thresholdCents - total;
      if (remaining < 0) remaining = 0;

      const thresholdStr = formatMoney(thresholdCents, cfg.moneyFormat, cfg.moneySample);
      const remainingStr = formatMoney(remaining, cfg.moneyFormat, cfg.moneySample);

      if (remaining > 0) {
        const pre = cfg.preMsg || 'You are %amount% away from free shipping';
        return pre
          .replace('%amount%', remainingStr)
          .replace('{amount}', remainingStr)
          .replace('%threshold%', thresholdStr)
          .replace('{threshold}', thresholdStr);
      }

      const unlocked = cfg.unlockedMsg || 'Congrats! You have unlocked free shipping';
      return unlocked
        .replace('%amount%', thresholdStr)
        .replace('{amount}', thresholdStr)
        .replace('%threshold%', thresholdStr)
        .replace('{threshold}', thresholdStr);
    };

    const setVisible = (el, show) => {
      if (!el) return;
      el.style.display = show ? '' : 'none';
    };

    const applyState = async (root, reason) => {
      const enabled = root.dataset.sfAnnEnabled === '1';
      if (!enabled) return;

      const mode = root.dataset.sfAnnMode || 'only_free_shipping';

      const cfg = {
        moneyFormat: JSON.parse(root.dataset.sfMoneyFormat || '"${{amount}}"'),
        moneySample: root.dataset.sfMoneySample || '',
        fsEnabled: root.dataset.sfFsEnabled || '0',
        threshold: root.dataset.sfFsThreshold || '0',
        preMsg: root.dataset.sfFsPre || '',
        unlockedMsg: root.dataset.sfFsUnlocked || '',
      };

      // Nodes
      const staticM = root.querySelector('[data-sf-ann-static-m]');
      const staticD = root.querySelector('[data-sf-ann-static-d]');
      const fsM = root.querySelector('[data-sf-ann-fs-m]');
      const fsD = root.querySelector('[data-sf-ann-fs-d]');

      // after_atc: switch after first cart mutation (persist per session)
      const key = 'sf_ann_fs_after_atc';
      const afterAtcFlag = sessionStorage.getItem(key) === '1';

      // Fetch cart to update message + decide visibility
      let cart = null;
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        cart = await res.json();
      } catch (e) {
        // If cart fetch fails, do not break header; just keep static
        setVisible(fsM, false);
        setVisible(fsD, false);
        setVisible(staticM, !!staticM);
        setVisible(staticD, true);
        return;
      }

      const hasItems = cart && typeof cart.item_count === 'number' ? cart.item_count > 0 : false;

      // ---------------------------
      // VISIBILITY RULES
      // ---------------------------
      let shouldShowFs = false;

      if (mode === 'only_free_shipping') {
        // Always show FS message (even if cart empty)
        shouldShowFs = true;
      } else if (mode === 'after_atc') {
        // FIX: if cart becomes empty, revert to static + clear the session flag
        if (!hasItems) {
          try {
            sessionStorage.removeItem(key);
          } catch (e) {}
          shouldShowFs = false;
        } else {
          // Cart has items; show FS after first ATC/mutation (flag) OR simply because items exist
          shouldShowFs = afterAtcFlag || hasItems;
        }
      }

      // If we should NOT show FS, show static and exit
      if (!shouldShowFs) {
        setVisible(fsM, false);
        setVisible(fsD, false);
        setVisible(staticM, !!staticM);
        setVisible(staticD, true);
        return;
      }

      // Compute message. If free shipping config is not enabled, fall back to static.
      const msg = computeFsMessage(cart, cfg);
      if (!msg) {
        setVisible(fsM, false);
        setVisible(fsD, false);
        setVisible(staticM, !!staticM);
        setVisible(staticD, true);
        return;
      }

      // Update + show FS spans, hide static spans
      fsM.textContent = msg;
      fsD.textContent = msg;

      setVisible(fsM, true);
      setVisible(fsD, true);
      setVisible(staticM, false);
      setVisible(staticD, false);
    };

    const markAfterAtc = () => {
      try {
        sessionStorage.setItem('sf_ann_fs_after_atc', '1');
      } catch (e) {}
    };

    const init = () => {
      // Initial render
      roots().forEach((r) => applyState(r, 'init'));

      // 1) Listen to common Dawn/theme events (best-effort)
      document.addEventListener('cart:updated', () => {
        markAfterAtc();
        roots().forEach((r) => applyState(r, 'cart:updated'));
      });
      document.addEventListener('cart:refresh', () => {
        markAfterAtc();
        roots().forEach((r) => applyState(r, 'cart:refresh'));
      });

      // 2) Monkey-patch fetch to catch any /cart/* mutations (ATC, change, update, clear)
      const origFetch = window.fetch;
      if (typeof origFetch === 'function' && !window.__sfAnnFetchPatched) {
        window.__sfAnnFetchPatched = true;
        window.fetch = function () {
          const args = arguments;
          const url = args[0] && typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

          const isCartMutation =
            url.includes('/cart/add') ||
            url.includes('/cart/change') ||
            url.includes('/cart/update') ||
            url.includes('/cart/clear');

          const p = origFetch.apply(this, args);

          if (isCartMutation) {
            // After the mutation completes, update the announcement instantly
            return p.then((resp) => {
              // Mark that ATC/mutation happened for "after_atc" mode
              markAfterAtc();

              // Trigger update on next microtask + RAF for safer DOM timing
              Promise.resolve().then(() => {
                requestAnimationFrame(() => roots().forEach((r) => applyState(r, 'fetch-cart-mutation')));
              });

              return resp;
            });
          }

          return p;
        };
      }

      // 3) Also update when cart drawer opens (some themes only update then)
      document.addEventListener(
        'click',
        (e) => {
          const t = e.target;
          if (!t) return;
          const btn = t.closest && t.closest('[aria-controls="CartDrawer"], #cart-icon-bubble');
          if (btn) {
            roots().forEach((r) => applyState(r, 'cart-open'));
          }
        },
        { passive: true }
      );
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  (function () {
    if (window.__sfHeaderCartBubbleInit) return;
    window.__sfHeaderCartBubbleInit = true;

    function getCartRoot() {
      return document.getElementById('cart-icon-bubble');
    }
function getVisibleCartCount(cart) {
  if (!cart || !Array.isArray(cart.items)) {
    return cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
  }

  return cart.items.reduce(function (total, item) {
    var props = item.properties || {};
    var bundleType = props._bundle_type || '';
    var bundleRole = props._bundle_role || props._pair_role || '';
    var pair1 = props['Pair 1'] || props._pair_1 || '';
    var pair2 = props['Pair 2'] || props._pair_2 || '';
    var quantity = Number(item.quantity || 0);

    // OUTFIT BUNDLE: Count both linked products as one set.
// Only skip leggings when their matching top exists.
var outfitGroup = props._sf_outfit_group || '';
var outfitRole = props._sf_outfit_role || '';

if (outfitGroup && outfitRole === 'leggings') {
  var matchingTopExists = cart.items.some(function (otherItem) {
    var otherProps = otherItem.properties || {};

    return (
      otherProps._sf_outfit_group === outfitGroup &&
      otherProps._sf_outfit_role === 'top'
    );
  });

  if (matchingTopExists) {
    return total;
  }
}

    if (bundleRole === 'pair_1') bundleRole = 'paid';
    if (bundleRole === 'pair_2') bundleRole = 'free';

    var titleText = String(
      item.product_title ||
      item.title ||
      item.handle ||
      item.url ||
      ''
    ).toLowerCase();

    var looksLikeFreePair =
      titleText.indexOf('free pair') !== -1 ||
      titleText.indexOf('free-pair') !== -1;

    var isFreeBogoLine = false;
    var isSameVariantBogoLine = false;

    if (bundleType === 'free_pair' && bundleRole === 'free') {
      isFreeBogoLine = true;
    }

    // Checkout-return fallback:
    // even if hidden properties are missing/changed, the free product title/handle still identifies it.
    if (!isFreeBogoLine && looksLikeFreePair) {
      isFreeBogoLine = true;
    }

    if (bundleType === 'free_pair' && !bundleRole && pair1 && pair2 && quantity > 1) {
      isSameVariantBogoLine = true;
    }

    if (isFreeBogoLine) {
      return total;
    }

    if (isSameVariantBogoLine) {
      return total + Math.ceil(quantity / 2);
    }

    return total + quantity;
  }, 0);
}

    function renderBubble(cart) {
      var root = getCartRoot();
      if (!root || !cart) return;

      var visibleCount = getVisibleCartCount(cart);
      var bubble = root.querySelector('.cart-count-bubble');

      if (visibleCount <= 0) {
        if (bubble) bubble.remove();
        root.setAttribute('aria-label', 'Cart');
        return;
      }

      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        root.appendChild(bubble);
      }

      bubble.innerHTML =
        '<span aria-hidden="true">' +
        (visibleCount < 100 ? visibleCount : '') +
        '</span>' +
        '<span class="visually-hidden">' +
        visibleCount +
        ' items in cart' +
        '</span>';

      root.setAttribute('aria-label', 'Cart, ' + visibleCount + ' items');
    }

    function fetchAndRenderBubble() {
      var rootUrl = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

      return fetch(rootUrl + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          renderBubble(cart);
        })
        .catch(function (error) {
          if (window.console && error) console.error(error);
        });
    }

    document.addEventListener('sf:cart:refresh', fetchAndRenderBubble);
    document.addEventListener('cart:refresh', fetchAndRenderBubble);
    document.addEventListener('cart:updated', fetchAndRenderBubble);

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData) {
          renderBubble(event.cartData);
        } else {
          fetchAndRenderBubble();
        }
      });
    }

    var originalFetch = window.fetch;

    if (typeof originalFetch === 'function' && !window.__sfHeaderCartFetchPatched) {
      window.__sfHeaderCartFetchPatched = true;

      window.fetch = function () {
        var args = arguments;
        var request = args[0];
        var url = typeof request === 'string' ? request : request && request.url ? request.url : '';

        var isCartMutation =
          url.indexOf('/cart/add') !== -1 ||
          url.indexOf('/cart/change') !== -1 ||
          url.indexOf('/cart/update') !== -1 ||
          url.indexOf('/cart/clear') !== -1;

        var promise = originalFetch.apply(this, args);

        if (isCartMutation) {
          return promise.then(function (response) {
            Promise.resolve().then(function () {
              window.requestAnimationFrame(fetchAndRenderBubble);
            });

            return response;
          });
        }

        return promise;
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fetchAndRenderBubble, { once: true });
    } else {
      fetchAndRenderBubble();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-header-new-design"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.rootSf = this.closest('[data-sf-header]') || this;
      this.sectionId = this.rootSf ? this.rootSf.getAttribute('data-sf-header') : null;
      this.sectionEl = this.sectionId ? document.getElementById(`shopify-section-${this.sectionId}`) : null;

      // Use THIS section wrapper as "header" reference (avoid grabbing another .section-header)
      this.header = this.sectionEl || this.closest('.section-header') || document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();
      this._mql = window.matchMedia('(max-width: 990px)');
      this._onMqlChange = this.setHeaderHeight.bind(this);
      this._mql.addEventListener('change', this._onMqlChange);

      // Device sticky toggles (default true if attribute missing)
      this.sfStickyD = this.rootSf ? (this.rootSf.getAttribute('data-sf-sticky-d') === 'true') : true;
      this.sfStickyM = this.rootSf ? (this.rootSf.getAttribute('data-sf-sticky-m') === 'true') : true;

      this._applySfStickyMode = () => {
        const root = this.rootSf;
        if (!root) return;

        const sectionId = root.getAttribute('data-sf-header');
        const sectionEl = document.getElementById(`shopify-section-${sectionId}`);
        if (!sectionEl) return;

        const isDesktop = window.matchMedia('(min-width: 990px)').matches;
        const enabled = isDesktop ? this.sfStickyD : this.sfStickyM;

        // When disabled: switch overlay to absolute (so it scrolls away)
        sectionEl.classList.toggle(`sf-sticky-disabled-${sectionId}`, !enabled);

        // Force "top/no-scroll" state when disabled
        if (!enabled) {
          if (this.header) {
            this.header.classList.remove('scrolled-past-header');
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
          }

          const scrolledClass = `sf-scrolled-${sectionId}`;
          const revealClass = `sf-ann-reveal-${sectionId}`;
          root.classList.remove(scrolledClass);
          root.classList.remove(revealClass);
        }

        this.setHeaderHeight();
      };

      window.addEventListener('resize', this._applySfStickyMode);
      this._applySfStickyMode();

      if (this.headerIsAlwaysSticky && this.isStickyEnabledNow()) {
        if (this.header) this.header.classList.add('shopify-section-header-sticky');
      } else if (this.header) {
        this.header.classList.remove('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.initSkinnifyNewDesignEnhancements();
    }

    isStickyEnabledNow() {
      const isDesktop = window.matchMedia('(min-width: 990px)').matches;
      return isDesktop ? this.sfStickyD : this.sfStickyM;
    }

    setHeaderHeight() {
      if (!this.header) return;

      // When sticky is OFF for the current viewport, keep hero "top start" (no layout offset)
      let stickyEnabled = true;
      const root = this.closest('[data-sf-header]');
      if (root) {
        const isDesktop = window.matchMedia('(min-width: 990px)').matches;
        const sd = root.getAttribute('data-sf-sticky-d') === 'true';
        const sm = root.getAttribute('data-sf-sticky-m') === 'true';
        stickyEnabled = isDesktop ? sd : sm;
      }

      if (!stickyEnabled) {
        document.documentElement.style.setProperty('--header-height', `0px`);
      } else {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this._mql && this._onMqlChange) this._mql.removeEventListener('change', this._onMqlChange);
      if (this._applySfStickyMode) window.removeEventListener('resize', this._applySfStickyMode);
    }

    createObserver() {
      if (!this.header) return;
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      // If sticky disabled for this viewport, keep header in "top/no-scroll" state always.
      if (!this.isStickyEnabledNow()) {
        if (!this.header) return;
        this.header.classList.remove('scrolled-past-header');
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      if (!this.header) return;
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      if (!this.header) return;
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }

    initSkinnifyNewDesignEnhancements() {
      const root = this.closest('[data-sf-header]');
      if (!root) return;

      if (root.dataset.sfScrollInit === '1') return;
      root.dataset.sfScrollInit = '1';

      const sectionId = root.getAttribute('data-sf-header');
      const scrolledClass = `sf-scrolled-${sectionId}`;
      const revealClass = `sf-ann-reveal-${sectionId}`;

      let lastScrolled = null;
      let revealTimer = null;
      let ticking = false;

      const stickyEnabledNow = () => {
        const isDesktop = window.matchMedia('(min-width: 990px)').matches;
        const sd = root.getAttribute('data-sf-sticky-d') === 'true';
        const sm = root.getAttribute('data-sf-sticky-m') === 'true';
        return isDesktop ? sd : sm;
      };

      const nudgeBackdrop = () => {
        root.style.setProperty('--sf-bdfix', '0.01px');
        requestAnimationFrame(() => root.style.setProperty('--sf-bdfix', '0px'));
      };

      const applyState = () => {
        ticking = false;

        // If sticky disabled, force "top/no-scroll" state (no scrolled pill; announcement stays).
        if (!stickyEnabledNow()) {
          root.classList.remove(scrolledClass);
          root.classList.remove(revealClass);
          lastScrolled = null;
          return;
        }

        const scrolled = window.scrollY > 2;

        if (scrolled) {
          root.classList.add(scrolledClass);
          root.classList.remove(revealClass);
          if (revealTimer) { clearTimeout(revealTimer); revealTimer = null; }
        } else {
          root.classList.remove(scrolledClass);

          nudgeBackdrop();

          if (lastScrolled === true) {
            root.classList.add(revealClass);
            if (revealTimer) clearTimeout(revealTimer);
            revealTimer = setTimeout(() => { root.classList.remove(revealClass); }, 700);
          } else {
            root.classList.remove(revealClass);
          }
        }

        lastScrolled = scrolled;
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(applyState);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      applyState();
    }
  }

  // Avoid "already defined" if another header exists in dev
  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  /* Fallback when sticky_header_type == 'none' */
  (() => {
    const initAll = () => {
      document.querySelectorAll('[data-sf-header]').forEach((root) => {
        if (root.dataset.sfScrollInit === '1') return;
        root.dataset.sfScrollInit = '1';

        const sectionId = root.getAttribute('data-sf-header');
        const scrolledClass = `sf-scrolled-${sectionId}`;
        const revealClass = `sf-ann-reveal-${sectionId}`;

        let lastScrolled = null;
        let revealTimer = null;
        let ticking = false;

        const stickyEnabledNow = () => {
          const isDesktop = window.matchMedia('(min-width: 990px)').matches;
          const sd = root.getAttribute('data-sf-sticky-d') === 'true';
          const sm = root.getAttribute('data-sf-sticky-m') === 'true';
          return isDesktop ? sd : sm;
        };

        const nudgeBackdrop = () => {
          root.style.setProperty('--sf-bdfix', '0.01px');
          requestAnimationFrame(() => root.style.setProperty('--sf-bdfix', '0px'));
        };

        const applyState = () => {
          ticking = false;

          if (!stickyEnabledNow()) {
            root.classList.remove(scrolledClass);
            root.classList.remove(revealClass);
            lastScrolled = null;
            document.documentElement.style.setProperty('--header-height', `0px`);
            return;
          }

          const scrolled = window.scrollY > 2;

          if (scrolled) {
            root.classList.add(scrolledClass);
            root.classList.remove(revealClass);
            if (revealTimer) { clearTimeout(revealTimer); revealTimer = null; }
          } else {
            root.classList.remove(scrolledClass);
            nudgeBackdrop();

            if (lastScrolled === true) {
              root.classList.add(revealClass);
              if (revealTimer) clearTimeout(revealTimer);
              revealTimer = setTimeout(() => { root.classList.remove(revealClass); }, 700);
            } else {
              root.classList.remove(revealClass);
            }
          }

          lastScrolled = scrolled;
        };

        const onScroll = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(applyState);
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        applyState();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
